import React from "react";
import styles from "./styles.module.scss";

const NotFound = ({ handleAddReward }) => {
  return (
    <div className={styles._wrapper}>
      <div className={styles._img}>
        <img src={"/assets/not-found.png"} alt="" />
      </div>
      <div className={styles._text}>
        <p>No rewards found</p>
      </div>
      <div className={styles._button}>
        <button onClick={handleAddReward}>Add Reward</button>
      </div>
    </div>
  );
};

export default NotFound;
